import { Box, Stack, Typography } from '@mui/material';
import QuarterTag from './QuarterTag';

import { memo } from 'react';
import InfoTooltip from './InfoTooltip';
import MonthEvents from './MonthEvents';
import ShortLargeValues from './ShortLargeValues';
import useForecastData from '../../Queries/forecastQuery';
import { getQuarterMonth, months, monthsNames } from '../../utils/monhts';
import { formatearNumeroConComas } from 'views/Components/Shared/utils/formatNumbers';

const MonthColumnHeader = memo(({ month, events }) => {
	const forecastQuery = useForecastData();
	const quoteCardsInfo = forecastQuery.data?.quoteCardsInfo;
	const monthCardInfo = quoteCardsInfo?.find(
		(monthInfo) => monthInfo?.mes_id === months.indexOf(month) + 1
	);

	return (
		<Box
			sx={{
				height: '164px',
				width: '450px',
				border: '1px solid #35488740',
				padding: '16px',
			}}
		>
			<Stack direction="row" spacing={2}>
				<Stack
					sx={{
						width: '40%',
					}}
					spacing={1}
				>
					<Stack direction="row" spacing="18px" alignItems="center">
						<QuarterTag quarter={getQuarterMonth(month)} />
						<Typography
							sx={{
								color: '#000000BF',
								fontWeight: 600,
								fontSize: '18px',
								fontFamily: 'Roboto',
								lineHeight: '24px',
								letterSpacing: '0.15px',
								textTransform: 'uppercase',
							}}
						>
							{monthsNames[month]}
						</Typography>
					</Stack>

					<Stack>
						<Typography
							sx={{
								color: '#00000061',
								fontWeight: 600,
								fontFamily: 'Roboto',
								fontSize: '14px',
								lineHeight: '24px',
								letterSpacing: '0.15px',
							}}
						>
							FX
						</Typography>
						<Stack direction={'row'} alignItems="center">
							<InfoTooltip title="Tasa de cambio" />

							<Typography
								sx={{
									color: '#000000DE',
									fontWeight: 400,
									fontFamily: 'Roboto',
									fontSize: '12px',
									lineHeight: '24px',
									letterSpacing: '0.15px',
									paddingLeft: '8px',
								}}
							>
								${formatearNumeroConComas(monthCardInfo?.tc_local)}
							</Typography>
						</Stack>
					</Stack>

					{events.length > 0 && <MonthEvents events={events} />}
				</Stack>

				<Stack
					sx={{
						borderLeft: '1px solid #35488740',
						borderRight: '1px solid #35488740',
						width: '35%',
						paddingX: '16px',
					}}
				>
					<Stack>
						<Typography
							sx={{
								color: '#00000061',
								fontWeight: 600,
								fontFamily: 'Roboto',
								fontSize: '14px',
								lineHeight: '24px',
								letterSpacing: '0.15px',
							}}
						>
							GMV USD
						</Typography>
						<Stack direction={'row'} alignItems="center">
							<InfoTooltip title="GMV USD total" />

							<Typography
								sx={{
									color: '#000000DE',
									fontWeight: 400,
									fontFamily: 'Roboto',
									fontSize: '12px',
									lineHeight: '24px',
									letterSpacing: '0.15px',
									paddingLeft: '8px',
								}}
							>
								U$D{' '}
								<ShortLargeValues
									value={monthCardInfo?.gmv_sum_usd_month}
									field="gmv_usd"
								/>
							</Typography>
						</Stack>
						<Stack direction={'row'} alignItems="center">
							<InfoTooltip title="GMV USD subtotal" />

							<Typography
								sx={{
									color: '#00000061',
									fontWeight: 400,
									fontFamily: 'Roboto',
									fontSize: '12px',
									lineHeight: '24px',
									letterSpacing: '0.15px',
									paddingLeft: '8px',
								}}
							>
								U$D{' '}
								<ShortLargeValues
									value={monthCardInfo?.gmv_sum_usd_month_filtered}
									field="gmv_usd"
								/>
							</Typography>
						</Stack>
					</Stack>
					<Stack>
						<Typography
							sx={{
								color: '#00000061',
								fontWeight: 600,
								fontFamily: 'Roboto',
								fontSize: '14px',
								lineHeight: '24px',
								letterSpacing: '0.15px',
							}}
						>
							GMV Local
						</Typography>
						<Stack direction={'row'} alignItems="center">
							<InfoTooltip title="GMV Local total" />

							<Typography
								sx={{
									color: '#000000DE',
									fontWeight: 400,
									fontFamily: 'Roboto',
									fontSize: '12px',
									lineHeight: '24px',
									letterSpacing: '0.15px',
									paddingLeft: '8px',
								}}
							>
								$
								<ShortLargeValues
									value={monthCardInfo?.gmv_sum_loc_month}
									field="gmv_local"
								/>
							</Typography>
						</Stack>
						<Stack direction={'row'} alignItems="center">
							<InfoTooltip title="GMV Local subtotal" />

							<Typography
								sx={{
									color: '#00000061',
									fontWeight: 400,
									fontFamily: 'Roboto',
									fontSize: '12px',
									lineHeight: '24px',
									letterSpacing: '0.15px',
									paddingLeft: '8px',
								}}
							>
								$
								<ShortLargeValues
									value={monthCardInfo?.gmv_sum_loc_month_filtered}
									field="gmv_local"
								/>
							</Typography>
						</Stack>
					</Stack>
				</Stack>

				<Stack
					sx={{
						width: '25%',
					}}
				>
					<Stack>
						<Typography
							sx={{
								color: '#00000061',
								fontWeight: 600,
								fontFamily: 'Roboto',
								fontSize: '14px',
								lineHeight: '24px',
								letterSpacing: '0.15px',
							}}
						>
							TSU
						</Typography>
						<Stack direction={'row'} alignItems="center">
							<InfoTooltip title="TSU total" />

							<Typography
								sx={{
									color: '#000000DE',
									fontWeight: 400,
									fontFamily: 'Roboto',
									fontSize: '12px',
									lineHeight: '24px',
									letterSpacing: '0.15px',
									paddingLeft: '8px',
								}}
							>
								{formatearNumeroConComas(monthCardInfo?.tsu_sum_month)}
							</Typography>
						</Stack>
						<Stack direction={'row'} alignItems="center">
							<InfoTooltip title="TSU subtotal" />

							<Typography
								sx={{
									color: '#00000061',
									fontWeight: 400,
									fontFamily: 'Roboto',
									fontSize: '12px',
									lineHeight: '24px',
									letterSpacing: '0.15px',
									paddingLeft: '8px',
								}}
							>
								{formatearNumeroConComas(monthCardInfo?.tsu_sum_month_filtered)}
							</Typography>
						</Stack>
					</Stack>
				</Stack>
			</Stack>
		</Box>
	);
});

export default MonthColumnHeader;
